import { Routes } from '@angular/router';
import { AuthGuard } from '../auth/auth.guard';

export const marketingRoutes: Routes = [
  {
    path: 'marketing',
    loadComponent: () =>
      import('./marketing.component').then((m) => m.MarketingComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'marketing/email-management',
    loadComponent: () =>
      import('./email-management/email-management.component').then(
        (m) => m.EmailManagementComponent
      ),
    canActivate: [AuthGuard],
  },
];
